import imgnotfound from '../../assets/images/image-not-found.png'

export const HandleError = (ev) => {
  ev.target.src = imgnotfound
}